"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoFeedComponent = void 0;
var react_1 = __importDefault(require("react"));
var VideoFeedComponent = function (props) {
    var _a = props.auction.live_stream, id = _a.id, stream_name = _a.stream_name;
    // const stream_id = process.env.MILLICAST_STREAM_ID;
    // console.log("millicast", millicast);
    // console.log(stream_id, stream_name);
    return (react_1.default.createElement("div", { className: "bg-black rounded-lg overflow-clip min-w-96 min-h-60 lg:min-h-72 grid" },
        react_1.default.createElement("iframe", { className: "w-full h-full", src: "https://viewer.millicast.com/?streamId=XXdh8F/".concat(stream_name) })));
};
exports.VideoFeedComponent = VideoFeedComponent;
